import { Component, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'

import { Breadcrumb } from '@/interfaces/breadcrumbs'
import { Vehicle } from '@/modules/Vehicle/interfaces/vehicle'
import { showErrors } from '@/utils/snack'
import { ApolloResponse } from '@/interfaces/apollo'
import { dateTimeToDisplay, dateToDisplay, dateToNow } from '@/utils/dateTime'
import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue'
import VehicleDetailDetail from '@/modules/Vehicle/views/detail.vue'
import AppTabs from '@/components/AppTabs.vue'
import AppDialog from '@/components/AppDialog.vue'
import AppTextSearch from '@/components/AppTextSearch.vue'
import AppCheckbox from '@/components/AppCheckbox.vue'
import AppRadio from '@/components/AppRadio.vue'
import RecordTypesHandler from '@/mixins/record-types'
import { getVehicle } from '@/modules/Vehicle/gql/vehicle.gql'

import VehicleDialog from '@/modules/Vehicle/scripts/vehicle-dialog'

@Component({
  components: {
    AppBreadcrumbs,
    VehicleDetailDetail,
    AppTabs,
    AppDialog,
    AppTextSearch,
    AppCheckbox,
    AppRadio
  }
})

export default class VehicleDetail extends mixins(VehicleDialog, RecordTypesHandler) {
  breadcrumbs: Breadcrumb[] = [
    {
      text: 'Vehicle'
    }
  ]

  vehicle: Vehicle | null = null

  tabActive = 0
  tabItems = [
    {
      title: 'Details',
      route: 'VehicleDetailDetail'
    },
    {
      title: 'Additional',
      route: 'VehicleDetailAdditional'
    }
  ]

  disableConfirm = false

  recordTypeIndex = 0

  initState = true

  get tabTitles () {
    return this.tabItems.map(item => item.title)
  }

  dateTimeToDisplay = dateTimeToDisplay
  dateToDisplay = dateToDisplay
  dateToNow = dateToNow

  mounted () {
    const { name } = this.$route
    const index = this.$R.findIndex((item: any) => item.route === name)(this.tabItems)
    this.tabActive = index
    this.getVehicle()
  }

  @Watch('$route.params.id')
  onRouteParamUpdate (val: string) {
    this.getVehicle()
  }

  async getVehicle () {
    const vehicleId = Number(this.$route.params.id)
    try {
      const result: ApolloResponse = await this.$apollo.query({
        query: getVehicle,
        variables: {
          vehicleId
        }
      })
      if (!result.data) {
        showErrors(result.errors)
        return
      }
      this.vehicle = result.data.getVehicle as Vehicle

      if (this.initState) {
        this.breadcrumbs.push({
          text: `${this.vehicle.name}`
        })
        this.initState = false
      }
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  clickTabHandler (index: number) {
    const item = this.tabItems[index]
    if (item.route && item.route !== this.$route.name) {
      this.$router.push({
        name: item.route
      })
    }
  }

  async deleteVehicleConfirm () {
    await this.deleteVehiclePost()
    this.$router.go(-1)
  }
}
